import React from 'react';

const ReviewDetails = ({Review}) => {
    return (
        <div className="col-sm-4 col-md-6">
            {/* <img src={}></img> */}
            <h1>Name: {Review.Name}</h1>
            <p>{Review.Review}</p>
        </div>
    );
};

export default ReviewDetails;